// Permission constants — extracted to a standalone file so they can be imported
// without pulling in SVG/icon dependencies from constants/index.js

export const ViewPermissions = {
  VIEW_REPORT: 'view_report',
  VIEW_REPORT_LOCKED: 'view_report_locked',
  VIEW_REPORT_UNLOCKED: 'view_report_unlocked',
  VIEW_INCOMPLETED_REPORTS: 'view_incompleted_reports',
  LOCK: 'lock',
  READ_LOCK: 'read_lock',
  UPDATE_LOCK: 'update_lock',
  REVIEW: 'review',
  UPDATE_REVIEW: 'update_review',
  READ_FIRST_MEETING: 'read_first_meeting',
  EDIT_FIRST_MEETING: 'edit_first_meeting',
  READ_PAID: 'read_paid',
  EDIT_PAID: 'edit_paid',
  ASSIGN_STAFF: 'assign_staff',
  EDIT_PATIENT: 'edit_patient',
  READ_PATIENT: 'read_patient',
  TOGGLE_EMAILS: 'toggle_emails',
  WRITE_INTERNAL_NOTE: 'write_internal_note',
  READ_INTERNAL_NOTE: 'read_internal_note',
  WRITE_PUBLIC_NOTE: 'write_public_note',
  READ_PUBLIC_NOTE: 'read_public_note',
  KIT_STATUS: 'kit_status',
  KIT_STATUS_SUMMARY: 'kit_status_summary',
  KIT_STATUS_FULL: 'kit_status_full',
  PROVIDE_LAB_UPDATE: 'provide_lab_update',
  BUSINESS_ANALYTICS: 'business_salary',
  READ_PATIENT_CHANGE_LOG: 'read_patient_change_log',
  READ_REVIEW: 'read_review',
  ORDER_KIT: 'order_kit',
  ADD_PATIENT: 'add_patient',
  EDIT_PENDING_PATIENT: 'edit_pending_patient',
  RESEND_PENDING_PATIENT_INVITE: 'resend_pending_patient_invite',
  CANCEL_PENDING_PATIENT: 'cancel_pending_patient',
  READ_PENDING_PATIENT_NOTES: 'read_pending_patient_notes',
  READ_PATIENT_MEDICATIONS: 'read_patient_medications'
};

export const AssignPermission = {
  SUPPORT: 'SUPPORT',
  COUNSELOR: 'COUNSELOR',
  FELLOW: 'FELLOW',
  PHARMACIST: 'PHARMACIST',
  DIETICIAN: 'DIETICIAN',
};

export const AssignedPermissions = {
  SUPPORT: [
    ViewPermissions.READ_LOCK,
    ViewPermissions.READ_REVIEW,
    ViewPermissions.VIEW_REPORT,
    ViewPermissions.VIEW_REPORT_LOCKED,
    ViewPermissions.VIEW_REPORT_UNLOCKED,
  ],
  DIETICIAN: [

  ]
};

export const UserRoleViewPermissions = {
  ADMINISTRATOR: [
    ViewPermissions.VIEW_REPORT,
    ViewPermissions.VIEW_REPORT_LOCKED,
    ViewPermissions.VIEW_REPORT_UNLOCKED,
    ViewPermissions.VIEW_INCOMPLETED_REPORTS,
    ViewPermissions.LOCK,
    ViewPermissions.UPDATE_LOCK,
    ViewPermissions.UPDATE_REVIEW,
    ViewPermissions.REVIEW,
    ViewPermissions.EDIT_FIRST_MEETING,
    ViewPermissions.READ_PAID,
    ViewPermissions.EDIT_PAID,
    ViewPermissions.ASSIGN_STAFF,
    ViewPermissions.EDIT_PATIENT,
    ViewPermissions.READ_PATIENT,
    ViewPermissions.TOGGLE_EMAILS,
    ViewPermissions.WRITE_INTERNAL_NOTE,
    ViewPermissions.READ_INTERNAL_NOTE,
    ViewPermissions.WRITE_PUBLIC_NOTE,
    ViewPermissions.READ_PUBLIC_NOTE,
    ViewPermissions.KIT_STATUS,
    ViewPermissions.PROVIDE_LAB_UPDATE,
    ViewPermissions.BUSINESS_ANALYTICS,
    ViewPermissions.READ_PATIENT_CHANGE_LOG,
    ViewPermissions.KIT_STATUS_SUMMARY,
    ViewPermissions.KIT_STATUS_FULL,
    ViewPermissions.EDIT_PENDING_PATIENT,
    ViewPermissions.RESEND_PENDING_PATIENT_INVITE,
    ViewPermissions.CANCEL_PENDING_PATIENT,
    ViewPermissions.READ_PENDING_PATIENT_NOTES,
    ViewPermissions.READ_PATIENT_MEDICATIONS
  ],
  STAFF_PHYSICIAN: [
    ViewPermissions.VIEW_REPORT,
    ViewPermissions.VIEW_INCOMPLETED_REPORTS,
    ViewPermissions.VIEW_REPORT_LOCKED,
    ViewPermissions.VIEW_REPORT_UNLOCKED,
    ViewPermissions.REVIEW,
    ViewPermissions.UPDATE_REVIEW,
    ViewPermissions.EDIT_FIRST_MEETING,
    ViewPermissions.READ_PAID,
    ViewPermissions.ASSIGN_STAFF,
    ViewPermissions.EDIT_PATIENT,
    ViewPermissions.READ_PATIENT,
    ViewPermissions.TOGGLE_EMAILS,
    ViewPermissions.WRITE_INTERNAL_NOTE,
    ViewPermissions.READ_INTERNAL_NOTE,
    ViewPermissions.WRITE_PUBLIC_NOTE,
    ViewPermissions.READ_PUBLIC_NOTE,
    ViewPermissions.KIT_STATUS,
    ViewPermissions.READ_PATIENT_CHANGE_LOG,
    ViewPermissions.ADD_PATIENT,
    ViewPermissions.EDIT_PENDING_PATIENT,
    ViewPermissions.RESEND_PENDING_PATIENT_INVITE,
    ViewPermissions.CANCEL_PENDING_PATIENT,
    ViewPermissions.READ_PENDING_PATIENT_NOTES,
    ViewPermissions.READ_PATIENT_MEDICATIONS,
  ],
  COUNSELOR: [
    ViewPermissions.VIEW_REPORT,
    ViewPermissions.VIEW_REPORT_LOCKED,
    ViewPermissions.VIEW_REPORT_UNLOCKED,
    ViewPermissions.EDIT_PATIENT,
    ViewPermissions.READ_PATIENT,
    ViewPermissions.WRITE_INTERNAL_NOTE,
    ViewPermissions.READ_INTERNAL_NOTE,
    ViewPermissions.WRITE_PUBLIC_NOTE,
    ViewPermissions.READ_PUBLIC_NOTE,
    ViewPermissions.KIT_STATUS,
    ViewPermissions.READ_LOCK,
    // Counselors assigned to a patient need medication context for counseling
    ViewPermissions.READ_PATIENT_MEDICATIONS,
  ],
  FELLOW: [
    ViewPermissions.VIEW_REPORT,
    ViewPermissions.VIEW_REPORT_LOCKED,
    ViewPermissions.VIEW_REPORT_UNLOCKED,
    ViewPermissions.READ_FIRST_MEETING,
    ViewPermissions.EDIT_FIRST_MEETING,
    ViewPermissions.LOCK,
    ViewPermissions.UPDATE_LOCK,
    ViewPermissions.READ_PATIENT,
    ViewPermissions.EDIT_PATIENT,
    ViewPermissions.WRITE_INTERNAL_NOTE,
    ViewPermissions.READ_INTERNAL_NOTE,
    ViewPermissions.WRITE_PUBLIC_NOTE,
    ViewPermissions.READ_PUBLIC_NOTE,
    // Fellows assigned to a patient via user_staff get medications access
    // through the PatientDetail inline permission merge.
    ViewPermissions.READ_PATIENT_MEDICATIONS,
  ],
  PHARMACIST: [
    ViewPermissions.EDIT_PATIENT,
    ViewPermissions.VIEW_REPORT,
    ViewPermissions.VIEW_REPORT_LOCKED,
    ViewPermissions.VIEW_REPORT_UNLOCKED,
    ViewPermissions.READ_PATIENT,
    ViewPermissions.WRITE_INTERNAL_NOTE,
    ViewPermissions.READ_INTERNAL_NOTE,
    ViewPermissions.WRITE_PUBLIC_NOTE,
    ViewPermissions.READ_PUBLIC_NOTE,
    ViewPermissions.KIT_STATUS,
    // Pharmacists need medication data to do their clinical work
    ViewPermissions.READ_PATIENT_MEDICATIONS,
  ],
  DIETICIAN: [
    ViewPermissions.VIEW_REPORT,
    ViewPermissions.VIEW_REPORT_LOCKED,
    ViewPermissions.VIEW_REPORT_UNLOCKED,
    ViewPermissions.READ_PATIENT,
    ViewPermissions.WRITE_INTERNAL_NOTE,
    ViewPermissions.READ_INTERNAL_NOTE,
    ViewPermissions.WRITE_PUBLIC_NOTE,
    ViewPermissions.READ_PUBLIC_NOTE,
    ViewPermissions.KIT_STATUS,
    // Dieticians assigned to a patient need medication context for nutrition planning
    ViewPermissions.READ_PATIENT_MEDICATIONS,
  ],
  SUPPORT: [
    ViewPermissions.VIEW_INCOMPLETED_REPORTS,
    ViewPermissions.READ_FIRST_MEETING,
    ViewPermissions.READ_PAID,
    ViewPermissions.ASSIGN_STAFF,
    ViewPermissions.EDIT_PATIENT,
    ViewPermissions.READ_PATIENT,
    ViewPermissions.TOGGLE_EMAILS,
    ViewPermissions.WRITE_INTERNAL_NOTE,
    ViewPermissions.READ_INTERNAL_NOTE,
    ViewPermissions.WRITE_PUBLIC_NOTE,
    ViewPermissions.READ_PUBLIC_NOTE,
    ViewPermissions.KIT_STATUS,
    ViewPermissions.READ_PATIENT_CHANGE_LOG,
    ViewPermissions.ADD_PATIENT,
    // Support cannot EDIT pending patients per backend (only Admin/StaffPhys/Manager)
    ViewPermissions.RESEND_PENDING_PATIENT_INVITE,
    ViewPermissions.CANCEL_PENDING_PATIENT,
  ],
  PHYSICIAN: [
    ViewPermissions.VIEW_REPORT,
    ViewPermissions.VIEW_REPORT_LOCKED,
    ViewPermissions.VIEW_REPORT_UNLOCKED,
    ViewPermissions.READ_PAID,
    ViewPermissions.READ_FIRST_MEETING,
    ViewPermissions.EDIT_FIRST_MEETING,
    ViewPermissions.LOCK,
    ViewPermissions.UPDATE_LOCK,
    ViewPermissions.READ_PATIENT,
    ViewPermissions.EDIT_PATIENT,
    ViewPermissions.ORDER_KIT,
    ViewPermissions.ADD_PATIENT,
  ],
  BUSINESS: [
    ViewPermissions.READ_FIRST_MEETING,
    ViewPermissions.READ_PAID,
    ViewPermissions.EDIT_PAID,
    ViewPermissions.READ_PATIENT,
    ViewPermissions.READ_PATIENT_CHANGE_LOG,
  ],
  BACKEND:[
    ViewPermissions.READ_FIRST_MEETING,
    ViewPermissions.ASSIGN_STAFF,
  ],
  MANAGER: [
    ViewPermissions.VIEW_REPORT,
    ViewPermissions.VIEW_INCOMPLETED_REPORTS,
    // Manager gets full report content access, matching the backend elevation
    // of ViewLockedReportData / ViewUnlockedReportData to include Manager.
    ViewPermissions.VIEW_REPORT_LOCKED,
    ViewPermissions.VIEW_REPORT_UNLOCKED,
    // Manager can lock/unlock reports. Backend Permission::LockReport already
    // includes Manager — both reportLock and reportUnlock mutations check it.
    // UPDATE_LOCK gates the LockStatusSwitch readonly state on desktop.
    ViewPermissions.LOCK,
    ViewPermissions.UPDATE_LOCK,
    // Manager does NOT have REVIEW or UPDATE_REVIEW — clinical review actions
    // stay with StaffPhysician only. Manager was briefly added (TMP-7) then
    // reverted. The ReviewSwitch renders as readonly for Manager.
    ViewPermissions.READ_FIRST_MEETING,
    ViewPermissions.READ_PAID,
    ViewPermissions.ASSIGN_STAFF,
    ViewPermissions.EDIT_PATIENT,
    ViewPermissions.READ_PATIENT,
    ViewPermissions.TOGGLE_EMAILS,
    ViewPermissions.KIT_STATUS,
    ViewPermissions.KIT_STATUS_SUMMARY,
    ViewPermissions.KIT_STATUS_FULL,
    ViewPermissions.READ_PATIENT_CHANGE_LOG,
    ViewPermissions.EDIT_PENDING_PATIENT,
    ViewPermissions.RESEND_PENDING_PATIENT_INVITE,
    ViewPermissions.CANCEL_PENDING_PATIENT,
    ViewPermissions.READ_PENDING_PATIENT_NOTES,
    ViewPermissions.READ_PATIENT_MEDICATIONS,
  ],
  SALES: [
    ViewPermissions.READ_PATIENT,
    ViewPermissions.READ_FIRST_MEETING,
    ViewPermissions.READ_PAID,
    ViewPermissions.KIT_STATUS,
    ViewPermissions.KIT_STATUS_SUMMARY,
    // Report metadata access — existence, counts, lock/review status.
    // Sales does NOT get VIEW_REPORT_LOCKED or VIEW_REPORT_UNLOCKED, which
    // the UI uses (via hasViewReportPermission) to gate the "View full report"
    // action link and the report content pages. Report rows are visible in
    // read-only mode; clicking through to content is hidden.
    ViewPermissions.VIEW_REPORT,
    ViewPermissions.VIEW_INCOMPLETED_REPORTS,
  ],
};
